import { render, staticRenderFns } from "./UserAccountSets.vue?vue&type=template&id=71ff9a5c"
import script from "./UserAccountSets.vue?vue&type=script&lang=js"
export * from "./UserAccountSets.vue?vue&type=script&lang=js"
import style0 from "./UserAccountSets.vue?vue&type=style&index=0&id=71ff9a5c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports